// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: scorecard.proto

import type { CallDirection } from './evaluation';

export const protobufPackage = 'compasspb';

/** ScoringType defines how a question is scored. */
export enum ScoringType {
  SCORING_TYPE_UNSPECIFIED = 0,
  SCORING_TYPE_BINARY = 1,
  SCORING_TYPE_SCALE = 2,
  SCORING_TYPE_TONE = 3,
}

/** ScoreDisplayType defines how scores are presented to users. */
export enum ScoreDisplayType {
  SCORE_DISPLAY_TYPE_UNSPECIFIED = 0,
  /** SCORE_DISPLAY_TYPE_PERCENTAGE - 0.85 → "85%" */
  SCORE_DISPLAY_TYPE_PERCENTAGE = 1,
  /** SCORE_DISPLAY_TYPE_LETTER - 0.85 → "A" (uses bands) */
  SCORE_DISPLAY_TYPE_LETTER = 2,
  /** SCORE_DISPLAY_TYPE_NUMERIC - 0.85 → "8.5/10" (uses max_value) */
  SCORE_DISPLAY_TYPE_NUMERIC = 3,
  /** SCORE_DISPLAY_TYPE_PASS_FAIL - 0.85 → "Pass" (uses pass_threshold) */
  SCORE_DISPLAY_TYPE_PASS_FAIL = 4,
  /** SCORE_DISPLAY_TYPE_YES_NO_PARTIAL - 0.0 → "No", 0.5 → "Partial", 1.0 → "Yes" */
  SCORE_DISPLAY_TYPE_YES_NO_PARTIAL = 5,
}

/**
 * TEMPORARY (AQ-437): request/response for BackfillScorecardMetadataKeys.
 * Remove together with the RPC after the migration.
 */
export interface BackfillScorecardMetadataKeysRequest {
  /** from path */
  organization_id?: string | undefined;
  /** from path; required — only this program's scorecards are touched */
  program_id?: string | undefined;
  /** stored (slugified) hyphen form, e.g. "skill-name" */
  add_valid_metadata_keys?: string[] | undefined;
}

export interface BackfillScorecardMetadataKeysResponse {
  scorecards_scanned?: number | undefined;
  /** scorecards that gained at least one new key */
  scorecards_updated?: number | undefined;
}

/** LetterGradeBand maps a normalized score range to a letter grade. */
export interface LetterGradeBand {
  /** e.g. "A", "B", "C" */
  label?: string | undefined;
  /** Minimum normalized score (inclusive) */
  min_score?: number | undefined;
}

/** ScoreDisplay configures how a normalized 0.0–1.0 score is presented. */
export interface ScoreDisplay {
  type?: ScoreDisplayType | undefined;
  /** For NUMERIC: e.g. 10 → "8.5/10" */
  max_value?: number | undefined;
  /** For PASS_FAIL: score >= threshold → "Pass" */
  pass_threshold?: number | undefined;
  /** For LETTER: grade boundaries */
  bands?: LetterGradeBand[] | undefined;
  /** For YES_NO_PARTIAL: score >= this → "Partial" (default 0.5) */
  partial_threshold?: number | undefined;
}

/**
 * ActivationRule defines a leaf condition (predicate) or branch node (combinator) in an activation rule tree.
 * Leaf nodes: source/fact/operator="=="|"in"|"exists", scalar value.
 * Branch nodes: operator="and"|"or"|"not", value=[]ActivationRule containing child rules.
 */
export interface ActivationRule {
  /** leaf: e.g. "metadata", "call_direction" */
  source?: string | undefined;
  /** leaf: The specific key, e.g. "call_types" */
  fact?: string | undefined;
  /** leaf: "==", "in", "exists" | branch: "and", "or", "not" */
  operator?: string | undefined;
  /** leaf: scalar value | branch: array of ActivationRule */
  value?: any | undefined;
}

/** ScorecardQuestion defines a single metric question within a section. */
export interface ScorecardQuestion {
  id?: string | undefined;
  label?: string | undefined;
  metric_key?: string | undefined;
  weight?: number | undefined;
  is_critical?: boolean | undefined;
  scoring_type?: ScoringType | undefined;
  /** Optional: overrides scorecard-level display for this question */
  score_display?: ScoreDisplay | undefined;
  /** Optional: call directions this question applies to */
  call_directions?: CallDirection[] | undefined;
  /** Optional: tree of conditions for when this question applies. Top-level entries are AND-ed; use branch nodes (operator "and"/"or"/"not") to express complex boolean expressions. */
  activation_rules?: ActivationRule[] | undefined;
  /** Optional: custom prompt/instructions for evaluating this question */
  prompt?: string | undefined;
  /** Optional: display title for the question */
  title?: string | undefined;
}

/** ScorecardSection defines a weighted group of questions. */
export interface ScorecardSection {
  id?: string | undefined;
  title?: string | undefined;
  weight?: number | undefined;
  questions?: ScorecardQuestion[] | undefined;
}

/** Scorecard represents a QC evaluation template. */
export interface Scorecard {
  id?: string | undefined;
  organization_id?: string | undefined;
  program_id?: string | undefined;
  name?: string | undefined;
  version?: number | undefined;
  is_active?: boolean | undefined;
  sections?: ScorecardSection[] | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
  created_by?: string | undefined;
  updated_by?: string | undefined;
  /** Default score display for all questions */
  score_display?: ScoreDisplay | undefined;
  /** Auto-incremented on every update, starts at 1 */
  revision?: number | undefined;
  /** Optional: feature slugs associated with this scorecard */
  features?: string[] | undefined;
  /** Optional: allowed metadata keys for evaluations on this scorecard */
  valid_metadata_keys?: string[] | undefined;
  /** Optional: AI prompt for detecting escalation */
  escalation_prompt?: string | undefined;
  /** Optional: AI prompt for detecting compliance failure */
  compliance_prompt?: string | undefined;
  /** Optional: program-level context injected into AI evaluations */
  evaluation_context?: string | undefined;
}

export interface CreateScorecardRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  name?: string | undefined;
  sections?: ScorecardSection[] | undefined;
  score_display?: ScoreDisplay | undefined;
  /** Optional: feature slugs associated with this scorecard */
  features?: string[] | undefined;
  /** Optional: allowed metadata keys for evaluations on this scorecard */
  valid_metadata_keys?: string[] | undefined;
  /** Optional: AI prompt for detecting escalation */
  escalation_prompt?: string | undefined;
  /** Optional: AI prompt for detecting compliance failure */
  compliance_prompt?: string | undefined;
  /** Optional: program-level context injected into AI evaluations */
  evaluation_context?: string | undefined;
}

export interface CreateScorecardResponse {
  scorecard?: Scorecard | undefined;
}

export interface GetScorecardRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  scorecard_id?: string | undefined;
}

export interface GetScorecardResponse {
  scorecard?: Scorecard | undefined;
}

export interface ListScorecardsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  is_active?: boolean | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
  /** When true, return all versions (active and inactive) */
  include_all_versions?: boolean | undefined;
}

export interface ListScorecardsResponse {
  scorecards?: Scorecard[] | undefined;
}

export interface UpdateScorecardRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  scorecard_id?: string | undefined;
  name?: string | undefined;
  sections?: ScorecardSection[] | undefined;
  score_display?: ScoreDisplay | undefined;
  /**
   * Feature updates — only one may be provided per request:
   *   features        = replace all features
   *   add_features    = add to existing features
   *   remove_features = remove specific features from existing
   */
  features?: string[] | undefined;
  /** Add feature slugs to existing */
  add_features?: string[] | undefined;
  /** Remove specific feature slugs from existing */
  remove_features?: string[] | undefined;
  /**
   * valid_metadata_keys updates — only one may be provided per request:
   *   valid_metadata_keys        = replace all keys
   *   add_valid_metadata_keys    = add to existing keys
   *   remove_valid_metadata_keys = remove specific keys from existing
   */
  valid_metadata_keys?: string[] | undefined;
  /** Add keys to existing */
  add_valid_metadata_keys?: string[] | undefined;
  /** Remove specific keys from existing */
  remove_valid_metadata_keys?: string[] | undefined;
  /** Optional: AI prompt for detecting escalation */
  escalation_prompt?: string | undefined;
  /** Optional: AI prompt for detecting compliance failure */
  compliance_prompt?: string | undefined;
  /** Optional: program-level context injected into AI evaluations */
  evaluation_context?: string | undefined;
}

export interface UpdateScorecardResponse {
  scorecard?: Scorecard | undefined;
}

export interface DeleteScorecardRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  scorecard_id?: string | undefined;
}

export interface DeleteScorecardResponse {
  success?: boolean | undefined;
}

/**
 * ScorecardService provides operations for managing QC scorecards.
 * Scorecards define evaluation criteria (sections, questions, weights) used
 * to assess call quality.
 */
export interface ScorecardService {
  /** Create a new scorecard */
  createScorecard(request: CreateScorecardRequest): Promise<CreateScorecardResponse>;
  /** Get a scorecard by ID */
  getScorecard(request: GetScorecardRequest): Promise<GetScorecardResponse>;
  /** List scorecards for a program */
  listScorecards(request: ListScorecardsRequest): Promise<ListScorecardsResponse>;
  /** Update a scorecard */
  updateScorecard(request: UpdateScorecardRequest): Promise<UpdateScorecardResponse>;
  /** Delete a scorecard */
  deleteScorecard(request: DeleteScorecardRequest): Promise<DeleteScorecardResponse>;
  /**
   * TEMPORARY (AQ-437 eval call-data migration) — ADMIN/MITIGATION ONLY, do not
   * call from application code. Appends the caller-supplied metadata keys to the
   * valid_metadata_keys of EVERY scorecard version of the given program, in place
   * (no new version). Needed because the core UpdateEvaluation validates metadata
   * against the eval's *pinned* scorecard version, so historical evals on old
   * versions reject the new keys. Idempotent (append/dedupe). System-admin only.
   * REMOVE this RPC once the backfill migration is complete.
   */
  backfillScorecardMetadataKeys(
    request: BackfillScorecardMetadataKeysRequest,
  ): Promise<BackfillScorecardMetadataKeysResponse>;
}
